<div class="contact-list">
  <div class="contact-list__head">
    <h4>Fax number</h4>
    <h4>Name</h4>
    <h4>Email</h4>
    <h4>Actions</h4>
  </div>

  <div *ngIf="isLoading; else contactsOrPlaceholder" class="contact-list__body">
    <div class="contact-list__row" *ngFor="let row of skeletonRows">
      <span class="skeleton contact-list__skeleton-cell"></span>
      <span class="skeleton contact-list__skeleton-cell"></span>
      <span class="skeleton contact-list__skeleton-cell"></span>
      <div class="contact-list__actions-cell">
        <span class="skeleton contact-list__skeleton-icon"></span>
        <span class="skeleton contact-list__skeleton-icon"></span>
        <span class="skeleton contact-list__skeleton-icon"></span>
      </div>
    </div>
  </div>

  <ng-template #contactsOrPlaceholder>
    <div *ngIf="doesContactsExist; else placeholder" class="contact-list__body">
      <div *ngFor="let contactsByAlphabetPair of contactsByAlphabet | keyvalue" class="contact-list__section">
        <h5 class="contact-list__section-title">
          {{ contactsByAlphabetPair.key }}
        </h5>

        <ul class="contact-list__section-body">
          <li *ngFor="let contact of contactsByAlphabetPair.value" class="contact-list__row">
            <span>{{ contact.faxNumber }}</span>

            <span class="contact-list__name-cell">{{ contact.name }}</span>

            <span>{{ contact.email }}</span>

            <div class="contact-list__actions-cell">
              <button class="icon-btn" (click)="sendToContactClick.emit(contact)">
                <img src="assets/icons/mail-orange.svg" alt="Send fax to contact" />
              </button>

              <button class="icon-btn" (click)="editContactClick.emit(contact)">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAIAAAC0Ujn1AAAACXBIWXMAABYlAAAWJQFJUiTwAAACvElEQVRIx62WS2tTQRiG33cSq7EIaVpRkdKVtkWtLqWtbVXqyoUrwY3W9BLpzn8g/gNBmwpWsDtdCCKi9QKxCoILMXFRL+hKCNQ0TRBtSavjYs6ZM3MuNa1+zGJmMuc573y3HMj/ZaW8fHBSLi/qDUopAaD4Bt+LAEAABOGfA6A7bxsEYzBtoSBzGQoi0YJj02hIAqCsfpV3zmCpBBKCICEURS1h7BMET0xh+0GLWyrI5xmqA4JINKP/FhqSAnP38LPksKiVauHmfhj3R1HmxpwDatTKeDGEWoW/r3SCgCBau7E15dEFAUB4b2L7aT9X2dxNvL8BrVpdMdEcd64M8uglbNuN+m11CfEEAHSmQeDDlKX90GXhhItO1Oq1Ul7eHUCp4Cw70ugYcb1HHL6G5H7hebN++5aXz8ZAylwGCy69/TzahzUXgPDCtQ7uqHfx2Qsou/Q9Qxi4rbgKzfVxn47qi1NNXo6j/M45kNipzwr3/ayL+2TEipUer8bxa9l3XDj1xjq59EtWo3sCsS0BtK6RNWw+Lx8Ph+sl0DOBpgPBh4RXbFyby3DJPVk/d6Vi+joaPJ+XM8NWuZujN4uUza1V8HpU+zpa8vxbOZM2WLbk3slwbq1sJx/DuI/8fvC4RwJcAB+vYqWswxZRMsuL8mE6Mm592RCubuj0hTHYegJ6Hcl9k0h1hQfGTjbhNeXgueDon0RzV3SShqpm6O1syf3X1+TCl2zRJWPr5cDfuOZTAIB4eL007uCp+94ynsDmZF1c42867jnapDOGxl3YgBmdTgR9tHGzk0040H/GWsG3fU1UvwQcZ2dViGftxWrVDmNqLyqfAMjZi+6XDUBSuA1A0Nz3L/WXkDAyVTmE+84FGpsRWOsnc9/4EtKhUvNNTa7qtkEScm4a1c86DqTdECJfZkNJtJ5Fy3GF/gNgsvmuHCJL4gAAAABJRU5ErkJggg=="
                  alt="Edit contact"
                  class="bi x0 y0 w0 h0"
                />
              </button>

              <button class="icon-btn" (click)="deleteContactClick.emit(contact)">
                <img src="assets/icons/delete-orange.svg" alt="Delete contact" />
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>

  <ng-template #placeholder>
    <div class="contact-list__body-placeholder">
      <p>No contacts found</p>
    </div>
  </ng-template>
</div>
